<div class="modal-header d-flex" [ngClass]="{'justify-content-center': isAuthGeneration, ' justify-content-between': !isAuthGeneration}">
  <div class="row thumbs_icon">
    <div class="ml-2">
      <h5 class="modal-title" id="exampleModalLongTitle"><span class="font-weight-bold text_baseline">{{header}} </span>
      </h5>
    </div>
  </div>
</div>
<div class="modal-body text-center px-3 py-3">
  <h4 *ngIf="!hasAlternatePayment">{{amount}}</h4>
  <h6>{{confirmMsg}}</h6>
  <p *ngIf="!isInput">
    <span *ngIf="isAuthGeneration; else normalBody">
      <strong [innerHTML]="body"></strong>
    </span>
    <ng-template #normalBody>
      <span [innerHTML]="body"></span>
    </ng-template>
  
    <span *ngIf="isAuthGeneration">
      {{ authGenreationInput }}
    </span>
  </p>

  <ngb-alert [dismissible]="false" *ngIf="isInput">
		<i class="feather icon-alert-triangle"></i> {{body}}
	</ngb-alert>

  <div class="col-sm-12 mt-4" *ngIf="isInput">
    <form [formGroup]="emailForm">
      <div class="form-group">
        <h5 class="control-label">{{inputLabel}} </h5>
        <input type="email" formControlName="email" class="form-control mt-2" placeholder="example@email.com">
        <div
            *ngIf="!emailForm.get('email').valid && emailForm.get('email').dirty">
            <ngb-alert [dismissible]="false" [type]="'danger'"
                *ngIf="emailForm.get('email').errors.required">
                {{'errorMsg.missingMail' | translate}}
            </ngb-alert>
            <ngb-alert [dismissible]="false" [type]="'danger'"
                *ngIf="emailForm.get('email').errors.hasEmail">
                {{'errorMsg.invalidMail' | translate}}
            </ngb-alert>
           
        </div>
        <div>
            <ngb-alert [dismissible]="false" [type]="'danger'" *ngIf="errorMsg && emailForm.get('email').valid">
                {{errorMsg}}
            </ngb-alert>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="card-footer">
    <button *ngIf="!isInput" (click)="closeModal()" class="btn btn-primary float-right mb-2 mr-2">
      <span *ngIf="enableConfirmSpinner" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span> {{confirmButtonLabel}}</button>
    <button *ngIf="isInput" (click)="saveEmail()" [disabled]="emailForm.get('email').invalid" class="btn btn-primary float-right mb-2 mr-2">
      <span *ngIf="enableConfirmSpinner" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span> {{confirmButtonLabel}}</button>
    <button *ngIf="!informationModal" type="button" (click)="cancelModal($event)" class="btn btn-danger mb-2 mr-2 float-right">{{cancelButtonLabel}}</button>
</div>
<div class="modal-body mb-2 mt-3" *ngIf="tipFlag">
  <p>
    <span class="tipClass mdi mdi-18px mdi-alert-circle-outline"></span> Tip adjust is not possible after the batch has been closed</p>
</div>
